<template>
    <fieldset class="mb-4 grid gap-4 border px-4 py-2">
        <legend>Controls</legend>
        <div>
            Leading icons
            <div class="flex items-center gap-6 pt-1">
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="leadingIcon"
                        type="radio"
                        value="fa-chevron-left"
                    />
                    <font-awesome-icon icon="fas fa-chevron-left" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="leadingIcon"
                        type="radio"
                        value="fa-times"
                    />
                    <font-awesome-icon icon="fas fa-times" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="leadingIcon"
                        type="radio"
                        value="fa-check"
                    />
                    <font-awesome-icon icon="fas fa-check" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="leadingIcon"
                        type="radio"
                        :value="leadingIconCustom"
                    />
                    <font-awesome-icon :icon="`fas ${leadingIconCustom}`" />
                    <input
                        v-model="leadingIconCustom"
                        class="rounded-md p-1"
                        type="text"
                    />
                </label>
            </div>
        </div>
        <div>
            Trailing icons
            <div class="flex items-center gap-6 pt-1">
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="trailingIcon"
                        type="radio"
                        value="fa-chevron-right"
                    />
                    <font-awesome-icon icon="fas fa-chevron-right" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="trailingIcon"
                        type="radio"
                        value="fa-times"
                    />
                    <font-awesome-icon icon="fas fa-times" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="trailingIcon"
                        type="radio"
                        value="fa-check"
                    />
                    <font-awesome-icon icon="fas fa-check" />
                </label>
                <label class="inline-flex items-center gap-2">
                    <input
                        v-model="trailingIcon"
                        type="radio"
                        :value="trailingIconCustom"
                    />
                    <font-awesome-icon :icon="`fas ${trailingIconCustom}`" />
                    <input
                        v-model="trailingIconCustom"
                        class="rounded-md p-1"
                        type="text"
                    />
                </label>
            </div>
        </div>
    </fieldset>

    <h2>Primary button</h2>
    <DsButtonSampleSet
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="primary"
    />

    <h2>Secondary button</h2>
    <DsButtonSampleSet
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="secondary"
    />

    <h2>Tertiary button</h2>
    <DsButtonSampleSet
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="tertiary"
    />

    <h2>Link button</h2>
    <DsButtonSampleSet
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="link-button"
    />

    <h2>Primary destructive button</h2>
    <DsButtonSampleSet
        destructive
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="primary"
    />

    <h2>Secondary destructive button</h2>
    <DsButtonSampleSet
        destructive
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="secondary"
    />

    <h2>Tertiary destructive button</h2>
    <DsButtonSampleSet
        destructive
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="tertiary"
    />

    <h2>Link button destructive</h2>
    <DsButtonSampleSet
        destructive
        :leading="leadingProp"
        :trailing="trailingProp"
        variant="link-button"
    />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import DsButtonSampleSet from './DsButtonSampleSet.vue';

const leadingIcon = ref('fa-chevron-left');
const trailingIcon = ref('fa-chevron-right');

const leadingIconCustom = ref('fa-circle-question');
const trailingIconCustom = ref('fa-circle-question');

const leadingProp = computed(() => `fas ${leadingIcon.value}`);
const trailingProp = computed(() => `fas ${trailingIcon.value}`);
</script>

<style scoped lang="scss">
h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;

    &:first-child {
        margin-top: 0;
    }
}

h3 {
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}
</style>
